<div class="container">
    
    <div
      class="email-verification-card"
    >
      <div class="status-indicator" style="background-color: green;">
        <mat-icon style="color:white">check_circle</mat-icon>
        </div>
        <!-- <img src="assets/baguio-logo-gov.png" alt="" style="height: 110px; width: 110px;"> -->
         
      <div class="message mt-5">
       
        <h1 class="fw-bold" style="color:green">Success!</h1>
          <p>Your account has been successfully created!<br> Please check your email to verify and activate your account.</p>  
        </div>
    </div>
    </div>
  
  